module.exports = __webpack_public_path__ + "media/images/product/d2-f7eb073b0a2590b5f54b90cf39d9a281.png";